import { defineMutator } from "@rocicorp/zero"

import type { MutatorTx } from "../schema"
import type { UpdateEmailSettingsArgs } from "../types"

export const emailSettingsMutators = {
	update: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: UpdateEmailSettingsArgs }) => {
			await tx.mutate.emailSettings.update(args)
		},
	),
}
